import _ from "lodash";
import { useEffect, useState } from "react";
interface IValues {
  [key: string]: string;
}

export const useDisableSubmit = (minStringLength = 1) => {
  const [isDisabled, setIsDisabled] = useState(true);
  const [initialValue, setInitialValue] = useState<{} | null>(null);
  useEffect(() => {
    setIsDisabled(!!initialValue);
  }, [initialValue]);

  const isValidEmail = (email: string) => {
    const regex = new RegExp(
      /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/,
      "g",
    );
    return regex.test(email);
  };
  const onUpdateValues = (values: IValues) => {
    if (
      "email" in values &&
      values.email &&
      !isValidEmail(values.email.toLowerCase())
    ) {
      setIsDisabled(true);
      return;
    }
    if (
      JSON.stringify(values) === JSON.stringify(initialValue) ||
      _.some(
        values,
        value => _.isEmpty(value) || value.trim().length < minStringLength,
      )
    ) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  };
  return { isDisabled, setInitialValue, onUpdateValues };
};
